import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";

/**
 * 公司发票分页列表-搜索条件分页列表-搜索条件
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchCompanyInvoice extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 公司Id
     */
    CompanyId?: string;
}

/**
 * 公司发票分页列表-搜索条件分页列表-搜索条件-表单校验
 */
export const DtoPageListSearchCompanyInvoiceRules = {
}

/**
 * 公司发票分页列表-搜索条件分页列表-搜索条件-动态搜索配置项
 */
export const DtoPageListSearchCompanyInvoiceDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
]
